import Header from 'groups/components/list/GroupsListHeader';
import Filters from 'groups/components/list/GroupsListFilters';
import Table from 'groups/components/list/GroupsListTable';
import Row from 'groups/components/list/GroupsListRow';

export default { Header, Filters, Table, Row };



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/components/list/index.js